export const language: any = {
  title: '食材',
  select_all: 'すべて選択',
  deselect_all: '選択解除',
  add: '食材を追加',
  add_title: '食材の追加方法を選択してください。',
  add_by_list: '食材を追加',
  add_total: '合計で {number} 種類の食材を追加',
  selecting: '選択した食材の合計',
  filter_title: 'ソート選択',
  filter_newest: '最新',
  filter_oldest: '最古',
  filter_alphabet: 'アルファベット順',
  get_recipe: 'AIの料理提案を取得',
  search_placeholder: '検索ワードを入力してください。',
  nodata: '該当する食材はありません。',
  request: '食材を追加',
  recipe_title: 'おすすめの料理',
  option: {
    title: 'オプション選択',
    desc: 'オプションの選択は必須ではありません。',
    complete: '完了',
    reset: 'リセット',
  },
  msg: {
    msg_7: "選択した食材を追加しますか？",
    msg_8: `
      <p>選択した食材を追加しますか？</p>
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> はすでに既存の食材に含まれているため、除外されます。)</p>
    `,
    msg_9: "選択した食材をショッピングカートに追加しますか？",
    msg_10: `
      <p>選択した食材をショッピングカートに追加しますか？<br />
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> はすでに既存の食材に含まれているため、除外されます。)</p>
    `,
    confirm: '追加',
    cancel: 'キャンセル',
    not_ingredient: '入力された内容は食材ではないようです。<br />もう一度確認してください。',
    ai_failed: '食材入力時にエラーが発生しました。<br />もう一度試してください。',
    ingredient_exist_should_exclued: `(<span class="text-primary">{name}</span> はすでに既存の食材に含まれているため、除外されます。)`,
  },
  history: "画像解析の履歴",
  myIngredient: "私の材料",
  history_no_data: "履歴がありません",
  history_take_photo: "写真を撮るか選択する",
}
